module.exports = __webpack_public_path__ + "static/media/pilotpath.91d84d0a.png";